<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Promotion information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end />
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-text-field
                  v-model="updateForm.promo_name"
                  :label="`${$t('Promotion Name')} *`"
                  name="Promotion Name"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Promotion Name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs12 pa-2>
                <v-autocomplete
                  v-model="updateForm.promo_outlet"
                  :items="outletsList"
                  :label="`${$t('Outlet')} *`"
                  box
                  hide-details
                  multiple
                  chips
                  deletable-chips
                  background-color="white"
                  class="text-capitalize"
                  :error="errors.has('Outlet')"
                  data-vv-name="Outlet"
                  v-validate="'required'"
                  :menu-props="{ transition: 'slide-y-transition' }"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption"
                      >(+{{ updateForm.promo_outlet.length - 3 }} others)</span
                    >
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-tile ripple @click="toggle">
                      <v-list-tile-action>
                        <v-icon
                          :color="
                            updateForm.promo_outlet != null
                              ? updateForm.promo_outlet.length > 0
                                ? 'indigo darken-4'
                                : ''
                              : ''
                          "
                          >{{ icon }}</v-icon
                        >
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Select All</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider />
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs4 sm4 class="pa-2">
                <v-menu v-model="startDateMenu" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="updateForm.promo_start_date"
                    :label="`${$t('Start Date')}`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="promo_start_date"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('promo_start_date')"
                    v-validate="'date_format:yyyy-MM-dd'"
                    ref="Start Date"
                  />
                  <v-date-picker @change="startDateMenu = false" v-model="updateForm.promo_start_date" />
                </v-menu>
              </v-flex>
              <v-flex xs4 sm4 class="pa-2">
                <v-menu v-model="endDateMenu" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="updateForm.promo_end_date"
                    :label="`${$t('End Date')}`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    background-color="white"
                    name="promo_end_date"
                    autocomplete="off"
                    data-vv-name="End Date"
                    :error="errors.has('End Date')"
                    v-validate="'date_format:yyyy-MM-dd|after:Start Date'"
                  />
                  <v-date-picker @change="endDateMenu = false" v-model="updateForm.promo_end_date" />
                </v-menu>
              </v-flex>
              <v-flex xs4 sm4 class="pa-2">
                <v-autocomplete
                  :items="customerRules"
                  v-model="updateForm.promo_customer_rule"
                  :label="`${$t('Customer Rule')} *`"
                  box
                  hide-details
                  browser-autocomplete
                  :error="errors.has('Customer Rule')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Customer Rule"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs12 sm12 class="pa-2" v-if="updateForm.promo_customer_rule === 'Group'">
                <v-autocomplete
                  v-model="updateForm.promo_customer_group"
                  :items="customerGroupsList"
                  :label="`${$t('Customer Group')} *`"
                  box
                  hide-details
                  deletable-chips
                  multiple
                  chips
                  browser-autocomplete
                  :error="errors.has('Customer Group')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Customer Group"
                  :menu-props="{ transition: 'slide-y-transition' }"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption"
                      >(+{{ updateForm.promo_customer_group.length - 3 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 class="pa-2">
                <v-autocomplete
                  :items="productRules"
                  v-model="updateForm.promo_product_rule"
                  :label="`${$t('Product Rule')} *`"
                  box
                  hide-details
                  :error="errors.has('Product Rule')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Product Rule"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs12 sm12 class="pa-2" v-if="updateForm.promo_product_rule === 'Product Type'">
                <v-autocomplete
                  v-model="updateForm.promo_customer_product_type"
                  :items="productTypesList"
                  :label="`${$t('Product Type')} *`"
                  box
                  hide-details
                  multiple
                  chips
                  deletable-chips
                  browser-autocomplete
                  :error="errors.has('Product Type')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Product Type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption"
                      >(+{{ updateForm.promo_customer_product_type.length - 3 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 class="pa-2" v-else-if="updateForm.promo_product_rule === 'Specific Products'">
                <v-autocomplete
                  v-model="updateForm.specific_products"
                  :items="productListSalesList"
                  :label="`${$t('Specific Product')} *`"
                  box
                  hide-details
                  multiple
                  chips
                  deletable-chips
                  browser-autocomplete
                  :error="errors.has('Specific Product')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Specific Product"
                  :menu-props="{ transition: 'slide-y-transition' }"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption"
                      >(+{{ updateForm.specific_products.length - 3 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs6 sm6 class="pa-2">
                <v-autocomplete
                  :items="amountRuleTypes"
                  v-model="updateForm.promo_rule_amount_or_quantity"
                  :label="`${$t('Amount Rule Type')} *`"
                  box
                  hide-details
                  :error="errors.has('Amount Rule Type')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Amount Rule Type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-text-field
                  v-model="updateForm.promo_rule_value"
                  :label="`${$t('Rule Value')} *`"
                  name="Rule Value"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Rule Value')"
                  v-validate="
                    updateForm.promo_rule_amount_or_quantity === 'Item Quantity'
                      ? 'required|decimal:3|min_value:1'
                      : 'required|decimal:3|min_value:1'
                  "
                  data-vv-delay="1000"
                />
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-autocomplete
                  :items="rewardTypes"
                  v-model="updateForm.promo_reward_type"
                  :label="`${$t('Reward Type')} *`"
                  box
                  hide-details
                  :error="errors.has('Reward Type')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Reward Type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-text-field
                  v-model="updateForm.promo_reward_value"
                  :label="`${$t('Reward Value')} *`"
                  name="Reward Value"
                  hide-details
                  box
                  :suffix="updateForm.promo_reward_type === 'Get Discount' ? '%' : ''"
                  background-color="white"
                  :error="errors.has('Reward Value')"
                  v-validate="'required|decimal:3|min_value:1'"
                  data-vv-delay="1000"
                />
              </v-flex>

              <v-flex xs12 class="px-2">
                <v-layout justify-start>
                  <v-flex sm3 md2 class="pt-3">
                    <v-chip
                      label
                      :color="updateForm.promo_status === 'Active' ? 'success' : 'error'"
                      text-color="white"
                    >
                      <v-icon left tabindex="-1">{{
                        updateForm.promo_status === 'Active' ? 'check_circle' : 'block'
                      }}</v-icon>
                      {{ updateForm.promo_status === 'Active' ? $t('Active') : $t('Inactive') }}
                    </v-chip>
                  </v-flex>
                  <v-checkbox
                    v-model="updateForm.promo_status"
                    :label="$t('Active')"
                    :true-value="'Active'"
                    :false-value="'Inactive'"
                    color="primary"
                    messages="Please note that if this option is unchecked this promotion will not be able to work with"
                  />
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12 class="pa-2">
                <v-textarea
                  v-model="updateForm.promo_description"
                  :label="`${$t('Description')}`"
                  name="promo_description"
                  hide-details
                  box
                  height="80"
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      endDateMenu: false,
      startDateMenu: false,
      updateForm: {
        promo_id: '',
        promo_name: '',
        promo_outlet: [],
        promo_start_date: '',
        promo_customer_rule: '',
        promo_end_date: '',
        promo_customer_group: [],
        promo_product_rule: '',
        promo_customer_product_type: [],
        specific_products: [],
        promo_rule_amount_or_quantity: '',
        promo_reward_type: '',
        promo_reward_value: '',
        promo_description: '',
        promo_rule_value: '',
        promo_status: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      promotionInfo: 'promotions/getPromotionInfo',
      outletsList: 'outlets/getFullOutletsList',
      customerGroupsList: 'customersGroups/getFullGroupsList',
      productTypesList: 'productTypes/getFullProductTypesList',
      productListSalesList: 'products/getFullSaleProductsList',
      customerRules: 'promotions/getCustomerRules',
      productRules: 'promotions/getProductRules',
      amountRuleTypes: 'promotions/getAmountRuleTypes',
      rewardTypes: 'promotions/getRewardTypes'
    }),

    selectAllOutlet() {
      if (this.updateForm.promo_outlet != null && this.outletsList.length != null) {
        return this.updateForm.promo_outlet.length === this.outletsList.length
      }
    },

    selectSomeOutlet() {
      if (this.updateForm.promo_outlet != null) {
        return this.updateForm.promo_outlet.length > 0 && !this.selectAllOutlet
      }
    },

    icon() {
      if (this.selectAllOutlet) return 'mdi-close-box'
      if (this.selectSomeOutlet) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.updateForm.promo_id = this.promotionInfo.promotion.promo_id
          this.updateForm.promo_name = this.promotionInfo.promotion.promo_name
          this.updateForm.promo_status = this.promotionInfo.promotion.promo_status
          this.updateForm.promo_outlet = this.promotionInfo.promotion.promo_outlet
          this.updateForm.promo_start_date = this.promotionInfo.promotion.promo_start_date
          this.updateForm.promo_customer_rule = this.promotionInfo.promotion.promo_customer_rule
          this.updateForm.promo_end_date = this.promotionInfo.promotion.promo_end_date
          this.updateForm.promo_customer_group = this.promotionInfo.promotion.promo_customer_group
          this.updateForm.promo_product_rule = this.promotionInfo.promotion.promo_product_rule
          this.updateForm.specific_products = []
          this.updateForm.promo_rule_amount_or_quantity = this.promotionInfo.promotion.promo_rule_amount_or_quantity
          this.updateForm.promo_reward_type = this.promotionInfo.promotion.promo_reward_type
          this.updateForm.promo_rule_value = this.promotionInfo.promotion.promo_rule_value
          this.updateForm.promo_reward_value = this.promotionInfo.promotion.promo_reward_value
          this.updateForm.promo_description = this.promotionInfo.promotion.promo_description

          this.parseOutletStringToArray()
          if (this.updateForm.promo_product_rule === 'Specific Products') {
            this.promotionInfo.specific_products.forEach(i => {
              this.updateForm.specific_products.push(i.product_id)
            })
          }
          if (this.updateForm.promo_product_rule === 'Product Type') {
            this.updateForm.promo_customer_product_type = this.promotionInfo.promotion.promo_customer_product_type
            this.parseProductTypeStringToArray()
          }

          if (this.updateForm.promo_customer_rule === 'Group') {
            this.parseCustomerStringToArray()
          }

          if (this.promotionInfo !== null) {
            this.addEscKeyListener()
          }
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updatePromotionInfo: 'promotions/updatePromotionInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    toggle() {
      this.$nextTick(() => {
        if (this.selectAllOutlet) {
          this.updateForm.promo_outlet = []
        } else {
          this.updateForm.promo_outlet = this.outletsList.slice()
        }
      })
    },

    parseOutletStringToArray() {
      this.updateForm.promo_outlet = this.updateForm.promo_outlet.split(',').map(item => {
        return parseInt(item)
      })
    },

    parseCustomerStringToArray() {
      this.updateForm.promo_customer_group = this.updateForm.promo_customer_group.split(',').map(item => {
        return parseInt(item)
      })
    },

    parseProductTypeStringToArray() {
      this.updateForm.promo_customer_product_type = this.updateForm.promo_customer_product_type.split(',').map(item => {
        return parseInt(item)
      })
    },

    parseSpecificProductStringToArray() {
      this.updateForm.specific_products = this.updateForm.specific_products.map(item => {
        return parseInt(item.product_id)
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true

            let formData = new FormData(event.target)
            formData.append('promo_name', this.updateForm.promo_name)
            formData.append('promo_customer_rule', this.updateForm.promo_customer_rule)
            formData.append('promo_product_rule', this.updateForm.promo_product_rule)
            formData.append('promo_rule_amount_or_quantity', this.updateForm.promo_rule_amount_or_quantity)
            formData.append('promo_rule_value', this.updateForm.promo_rule_value)
            formData.append('promo_reward_type', this.updateForm.promo_reward_type)
            formData.append('promo_reward_value', this.updateForm.promo_reward_value)
            formData.append('promo_status', this.updateForm.promo_status)
            formData.set('promo_start_date', this.updateForm.promo_start_date || '')
            formData.set('promo_end_date', this.updateForm.promo_end_date || '')

            if (this.updateForm.promo_customer_rule === 'Group') {
              this.updateForm.promo_customer_group.forEach((customerGroup, index) => {
                formData.append('promo_customer_group[' + [index] + ']', customerGroup)
              })
            } else {
              this.updateForm.promo_customer_group = []
            }

            if (this.updateForm.promo_product_rule === 'Product Type') {
              this.updateForm.promo_customer_product_type.forEach((ProductType, index) => {
                formData.append('promo_customer_product_type[' + [index] + ']', ProductType)
              })
            } else if (this.updateForm.promo_product_rule === 'Specific Products') {
              this.updateForm.specific_products.forEach((SpecificProducts, index) => {
                formData.append('specific_products[' + [index] + ']', SpecificProducts)
              })
            }

            if (this.selectAllOutlet) {
              this.updateForm.promo_outlet.forEach((outlet, index) => {
                formData.append('promo_outlet[' + [index] + ']', outlet)
              })
            } else {
              this.updateForm.promo_outlet.forEach((outlet, index) => {
                formData.append('promo_outlet[' + [index] + ']', outlet)
              })
            }

            let payload = { id: this.updateForm.promo_id, formData }
            this.updatePromotionInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
